<!-- भारतीय सड़क परियोजना प्रबंधन प्रणाली - Enhanced GIS Editor v2.5 -->
<div class="gis-editor">
  <!-- Top Header -->
  <div class="top-header">
    <div class="header-left">
      <h1 class="app-title">GIS Editor OpenLayers</h1>
    </div>
    <div class="header-right">
      <div class="project-selector">
        <label>Project: IRB</label>
        <!-- <select [(ngModel)]="selectedProject" (change)="onProjectChange($event)">
          <option *ngFor="let project of projects" [value]="project">{{ project }}</option>
        </select> -->
      </div>
      <!-- <button class="btn-settings" (click)="openSettings()">
        <i class="bi bi-gear"></i> Settings
      </button> -->
      <button class="btn-snapshot" (click)="takeSnapshot()">
        <i class="bi bi-camera"></i> Snapshot
      </button>
    </div>
  </div>

  <!-- Main Navigation Tabs -->
  <div *ngIf="false" class="nav-tabs">
    <button class="nav-tab active">Draw</button>
    <button class="nav-tab">Road</button>
    <button class="nav-tab">Survey</button>
    <button class="nav-tab">Mgmt</button>
    <button class="nav-tab">Bio</button>
    <button class="nav-tab">Docs</button>
    <button class="nav-tab">Config</button>
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Left Sidebar - Drawing Tools -->
    <div class="left-sidebar">
      <div class="drawing-tools-panel">
        <h3 class="panel-title">
          <i class="bi bi-palette"></i> Drawing Tools
        </h3>
        
        <!-- Drawing Mode -->
        <div class="control-group">
          <label>Drawing Mode:</label>
          <select [(ngModel)]="currentDrawingMode" (change)="setDrawingMode($event)">
            <option value="select">Select Tool</option>
            <option value="point">Point</option>
            <option value="line">Line</option>
            <option value="polygon">Polygon</option>
            <option value="text">Text</option>
          </select>
        </div>

        <!-- Line Color Palette -->
        <div class="control-group">
          <label>Line Color Palette:</label>
          <div class="color-palette">
            <div *ngFor="let color of lineColors" 
                 class="color-swatch" 
                 [style.background-color]="color"
                 [class.selected]="lineColor === color"
                 (click)="setLineColor(color)">
            </div>
          </div>
        </div>

        <!-- Line Width -->
        <div class="control-group">
          <label>Line Width:</label>
          <div class="slider-container">
            <input type="range" 
                   min="1" 
                   max="10" 
                   [(ngModel)]="lineWidth" 
                   (input)="setLineWidth($event)"
                   class="slider">
            <span class="slider-value">{{ lineWidth }}px</span>
          </div>
        </div>

        <!-- Symbol Size -->
        <div class="control-group">
          <label>Symbol Size:</label>
          <div class="slider-container">
            <input type="range" 
                   min="0.5" 
                   max="3" 
                   step="0.1"
                   [(ngModel)]="symbolSize" 
                   (input)="setSymbolSize($event)"
                   class="slider">
            <span class="slider-value">{{ symbolSize }}x</span>
          </div>
        </div>

        <!-- Text Content -->
        <div class="control-group">
          <label>Text Content:</label>
          <input type="text" 
                 [(ngModel)]="textContent" 
                 (input)="setTextContent($event)"
                 placeholder="Enter text"
                 class="text-input">
        </div>

        <!-- Text Color Palette -->
        <div class="control-group">
          <label>Text Color Palette:</label>
          <div class="color-palette">
            <div *ngFor="let color of textColors" 
                 class="color-swatch" 
                 [style.background-color]="color"
                 [class.selected]="textColor === color"
                 (click)="setTextColor(color)">
            </div>
          </div>
        </div>

        <!-- Text Formatting -->
        <div class="control-group">
          <label>Text Formatting:</label>
          <div class="formatting-controls">
            <button class="format-btn" 
                    [class.active]="textFormatting.bold"
                    (click)="toggleTextFormatting('bold')">
              <strong>B</strong>
            </button>
            <button class="format-btn" 
                    [class.active]="textFormatting.italic"
                    (click)="toggleTextFormatting('italic')">
              <em>I</em>
            </button>
            <button class="format-btn" 
                    [class.active]="textFormatting.underline"
                    (click)="toggleTextFormatting('underline')">
              <u>U</u>
            </button>
            <select [(ngModel)]="textFormatting.fontSize" 
                                         (change)="setFontSize($event)"
                    class="font-size-select">
              <option value="12">12px</option>
              <option value="14">14px</option>
              <option value="16">16px</option>
              <option value="18">18px</option>
              <option value="20">20px</option>
              <option value="24">24px</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Comments Section -->
      <div class="comments-panel">
        <h3 class="panel-title">
          <i class="bi bi-chat-text"></i> Comments
        </h3>
        <div class="control-group">
          <textarea 
            [(ngModel)]="comments" 
            (input)="updateComments($event)"
            placeholder="Add comments for this feature..."
            class="comments-textarea"
            rows="4">
          </textarea>
        </div>
      </div>

      <!-- Enhanced Segment Management -->
      <div class="segment-management-panel">
        <h3 class="panel-title">
          <i class="bi bi-bar-chart"></i> Enhanced Segment Management
        </h3>
        
        <!-- Numbering Type -->
        <div class="control-group">
          <label>Numbering Type:</label>
          <select [(ngModel)]="numberingType" (change)="updateNumberingType($event)">
            <option value="auto">Auto Numbering</option>
            <option value="manual">Manual Numbering</option>
          </select>
        </div>

        <!-- Prefix/Suffix Inputs -->
        <div class="control-group">
          <label>Prefix:</label>
          <input type="text" 
                 [(ngModel)]="segmentPrefix" 
                 (input)="updateSegmentPrefix($event)"
                 class="text-input">
        </div>

        <div class="control-group">
          <label>Suffix:</label>
          <input type="text" 
                 [(ngModel)]="segmentSuffix" 
                 (input)="updateSegmentSuffix($event)"
                 class="text-input">
        </div>

        <!-- Segment Drawing Mode -->
        <div class="control-group">
          <label>Drawing Mode:</label>
          <div class="segment-drawing-controls">
            <button class="segment-btn" 
                    [class.active]="isSegmentDrawing"
                    (click)="startSegmentDrawing()">
              Draw Segment
            </button>
            <button class="segment-btn" 
                    (click)="stopSegmentDrawing()">
              Stop Drawing
            </button>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="segment-buttons">
          <button class="segment-btn" (click)="addSegment()">+ Segment</button>
          <button class="segment-btn" (click)="addSubSegment()">+ Sub-Seg</button>
          <button class="segment-btn" (click)="divideRoad()">Divide Road</button>
          <button class="segment-btn" (click)="resetNumbering()">Reset #</button>
        </div>

        <!-- Construction Management Button -->
        <div class="construction-button" *ngIf="selectedSegment">
          <button class="btn-primary" (click)="toggleConstructionManager()">
            <i class="bi bi-hammer"></i> Construction Manager
          </button>
        </div>

        <!-- Segment Import/Export -->
        <div class="segment-buttons">
          <button class="segment-btn" (click)="exportSegments()">Export</button>
          <button class="segment-btn" (click)="triggerSegmentImport()">Import</button>
        </div>

        <!-- Current Segment Display -->
        <div class="current-segment">
          <label>Current:</label>
          <span class="current-segment-text">{{ currentSegment }}</span>
        </div>

        <!-- Segments List -->
        <div class="segments-list" *ngIf="segments.length > 0">
          <h4>Segments ({{ segments.length }})</h4>
          <div class="segment-item" 
               *ngFor="let segment of segments; let i = index"
               [class.selected]="segment.isSelected">
            <div class="segment-header" (click)="selectSegment(segment)">
              <div class="segment-info">
                <span class="segment-number">{{ i + 1 }}</span>
                <div class="segment-details">
                  <strong>{{ segment.name }}</strong>
                  <div class="segment-description">
                    {{ segment.comments || 'No description' }}
                  </div>
                </div>
              </div>
              <div class="segment-actions">
                <button class="btn-small" 
                        (click)="toggleSegmentVisibility(segment); $event.stopPropagation()"
                        [title]="segment.isVisible ? 'Hide' : 'Show'">
                  <i class="bi" [class.bi-eye]="segment.isVisible" [class.bi-eye-slash]="!segment.isVisible"></i>
                </button>
                <button class="btn-small" 
                        (click)="editSegmentProperties(segment); $event.stopPropagation()"
                        title="Edit">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn-small" 
                        (click)="deleteSegment(segment); $event.stopPropagation()"
                        title="Delete">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
            
            <!-- Sub-segments -->
            <div class="subsegment-list" *ngIf="segment.subSegments.length > 0">
              <div class="subsegment-item" 
                   *ngFor="let subSegment of segment.subSegments; let j = index"
                   [class.selected]="subSegment.isSelected">
                <div class="subsegment-info">
                  <span class="subsegment-number">{{ j + 1 }}</span>
                  <div class="subsegment-details">
                    <strong>{{ subSegment.name }}</strong>
                    <div class="subsegment-description">
                      {{ subSegment.comments || 'No description' }}
                    </div>
                  </div>
                </div>
                <div class="subsegment-actions">
                  <button class="btn-small" 
                          (click)="toggleSegmentVisibility(subSegment); $event.stopPropagation()"
                          [title]="subSegment.isVisible ? 'Hide' : 'Show'">
                    <i class="bi" [class.bi-eye]="subSegment.isVisible" [class.bi-eye-slash]="!subSegment.isVisible"></i>
                  </button>
                  <button class="btn-small" 
                          (click)="editSegmentProperties(subSegment); $event.stopPropagation()"
                          title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn-small" 
                          (click)="deleteSegment(subSegment); $event.stopPropagation()"
                          title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- No segments message -->
        <div class="no-segments" *ngIf="segments.length === 0">
          <i class="bi bi-road"></i>
          <p>No segments created yet</p>
          <p>Click "Draw Segment" to start creating road segments</p>
        </div>
      </div>

      <!-- Construction Management Panel -->
      <div class="construction-management-panel" *ngIf="showConstructionManager">
        <h3 class="panel-title">
          <i class="bi bi-hammer"></i> Construction Management
        </h3>

        <!-- Construction Manager Toggle -->
        <div class="control-group">
          <button class="btn-primary" (click)="toggleConstructionManager()">
            <i class="bi bi-x"></i> Close Construction Manager
          </button>
        </div>

        <!-- Selected Segment Info -->
        <div class="selected-segment-info" *ngIf="selectedConstructionSegment">
          <h4>{{ selectedConstructionSegment.name }}</h4>
          <div class="segment-status" *ngIf="selectedConstructionSegment.construction">
            <span class="status-badge" 
                  [style.background-color]="getConstructionStatusColor(selectedConstructionSegment.construction.status)">
              {{ selectedConstructionSegment.construction.status | titlecase }}
            </span>
            <span class="priority-badge" 
                  [style.background-color]="getPriorityColor(selectedConstructionSegment.construction.priority)">
              {{ selectedConstructionSegment.construction.priority | titlecase }}
            </span>
          </div>
        </div>

        <!-- Construction Setup Form -->
        <div class="construction-setup" *ngIf="selectedConstructionSegment && !selectedConstructionSegment.construction">
          <h4>Setup Construction</h4>
          <div class="form-group">
            <label>Construction Type:</label>
            <select [(ngModel)]="constructionForm.type">
              <option *ngFor="let type of constructionTypes" [value]="type">{{ type | titlecase }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Status:</label>
            <select [(ngModel)]="constructionForm.status">
              <option *ngFor="let status of constructionStatuses" [value]="status">{{ status | titlecase }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Priority:</label>
            <select [(ngModel)]="constructionForm.priority">
              <option *ngFor="let priority of priorities" [value]="priority">{{ priority | titlecase }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Estimated Cost (₹):</label>
            <input type="number" [(ngModel)]="constructionForm.estimatedCost" placeholder="0">
          </div>
          <div class="form-group">
            <label>Estimated Duration (days):</label>
            <input type="number" [(ngModel)]="constructionForm.estimatedDuration" placeholder="30">
          </div>
          <div class="form-group">
            <label>Contractor:</label>
            <input type="text" [(ngModel)]="constructionForm.contractor" placeholder="Contractor name">
          </div>
          <div class="form-group">
            <label>Supervisor:</label>
            <input type="text" [(ngModel)]="constructionForm.supervisor" placeholder="Supervisor name">
          </div>
          <div class="form-group">
            <label>Materials (comma-separated):</label>
            <textarea [(ngModel)]="constructionForm.materials" placeholder="Concrete, Steel, etc."></textarea>
          </div>
          <div class="form-group">
            <label>Equipment (comma-separated):</label>
            <textarea [(ngModel)]="constructionForm.equipment" placeholder="Excavator, Crane, etc."></textarea>
          </div>
          <button class="btn-primary" (click)="addConstructionToSegment(selectedConstructionSegment)">
            <i class="bi bi-plus"></i> Setup Construction
          </button>
        </div>

        <!-- Construction Management Tabs -->
        <div class="construction-tabs" *ngIf="selectedConstructionSegment?.construction">
          <div class="tab-buttons">
            <button class="tab-btn active" data-tab="nodes">Nodes</button>
            <button class="tab-btn" data-tab="phases">Phases</button>
            <button class="tab-btn" data-tab="progress">Progress</button>
          </div>

          <!-- Nodes Tab -->
          <div class="tab-content" data-tab="nodes">
            <div class="node-management">
              <h4>Construction Nodes</h4>
              
              <!-- Node Drawing Controls -->
              <div class="node-controls">
                <div class="form-group">
                  <label>Node Type:</label>
                  <select [(ngModel)]="selectedNodeType">
                    <option *ngFor="let type of nodeTypes" [value]="type">{{ type | titlecase }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Node Name:</label>
                  <input type="text" [(ngModel)]="newNodeForm.name" placeholder="Node name">
                </div>
                <div class="form-group">
                  <label>Assigned To:</label>
                  <input type="text" [(ngModel)]="newNodeForm.assignedTo" placeholder="Person/Team">
                </div>
                <div class="form-group">
                  <label>Priority:</label>
                  <select [(ngModel)]="newNodeForm.priority">
                    <option *ngFor="let priority of priorities" [value]="priority">{{ priority | titlecase }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Estimated Duration (days):</label>
                  <input type="number" [(ngModel)]="newNodeForm.estimatedDuration" min="1">
                </div>
                <div class="form-group">
                  <label>Notes:</label>
                  <textarea [(ngModel)]="newNodeForm.notes" placeholder="Additional notes"></textarea>
                </div>
                <div class="node-buttons">
                  <button class="btn-primary" 
                          [class.active]="isNodeDrawing"
                          (click)="startNodeDrawing()">
                    <i class="bi bi-geo-alt"></i> Draw Node
                  </button>
                  <button class="btn-secondary" (click)="stopNodeDrawing()">
                    <i class="bi bi-stop"></i> Stop Drawing
                  </button>
                </div>
              </div>

              <!-- Nodes List -->
              <div class="nodes-list" *ngIf="selectedConstructionSegment.construction.nodes.length > 0">
                <h5>Nodes ({{ selectedConstructionSegment.construction.nodes.length }})</h5>
                <div class="node-item" 
                     *ngFor="let node of selectedConstructionSegment.construction.nodes; let i = index"
                     [class.selected]="node.isSelected"
                     (click)="selectNode(node)">
                  <div class="node-info">
                    <div class="node-type-badge" [style.background-color]="getNodeTypeColor(node.type)">
                      {{ node.type | titlecase }}
                    </div>
                    <div class="node-details">
                      <strong>{{ node.name }}</strong>
                      <div class="node-properties">
                        <span class="status-badge" 
                              [style.background-color]="getPriorityColor(node.properties.priority)">
                          {{ node.properties.priority | titlecase }}
                        </span>
                        <span class="duration">{{ node.properties.estimatedDuration }} days</span>
                      </div>
                      <div class="node-notes" *ngIf="node.properties.notes">
                        {{ node.properties.notes }}
                      </div>
                    </div>
                  </div>
                  <div class="node-actions">
                    <button class="btn-small" 
                            (click)="deleteNode(node, selectedConstructionSegment); $event.stopPropagation()"
                            title="Delete Node">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- No nodes message -->
              <div class="no-nodes" *ngIf="selectedConstructionSegment.construction.nodes.length === 0">
                <i class="bi bi-geo-alt"></i>
                <p>No nodes created yet</p>
                <p>Click "Draw Node" to start placing construction nodes</p>
              </div>
            </div>
          </div>

          <!-- Phases Tab -->
          <div class="tab-content" data-tab="phases">
            <div class="phase-management">
              <h4>Construction Phases</h4>
              
              <!-- Add Phase Form -->
              <div class="phase-form">
                <h5>Add New Phase</h5>
                <div class="form-group">
                  <label>Phase Name:</label>
                  <input type="text" [(ngModel)]="newPhaseForm.name" placeholder="Phase name">
                </div>
                <div class="form-group">
                  <label>Description:</label>
                  <textarea [(ngModel)]="newPhaseForm.description" placeholder="Phase description"></textarea>
                </div>
                <div class="form-group">
                  <label>Estimated Cost (₹):</label>
                  <input type="number" [(ngModel)]="newPhaseForm.estimatedCost" placeholder="0">
                </div>
                <div class="form-group">
                  <label>Estimated Duration (days):</label>
                  <input type="number" [(ngModel)]="newPhaseForm.estimatedDuration" placeholder="1">
                </div>
                <div class="form-group">
                  <label>Deliverables (comma-separated):</label>
                  <textarea [(ngModel)]="newPhaseForm.deliverables" placeholder="Deliverable 1, Deliverable 2"></textarea>
                </div>
                <div class="form-group">
                  <label>Quality Standards (comma-separated):</label>
                  <textarea [(ngModel)]="newPhaseForm.qualityStandards" placeholder="Standard 1, Standard 2"></textarea>
                </div>
                <div class="form-group">
                  <label>Safety Requirements (comma-separated):</label>
                  <textarea [(ngModel)]="newPhaseForm.safetyRequirements" placeholder="Requirement 1, Requirement 2"></textarea>
                </div>
                <button class="btn-primary" (click)="addPhaseToSegment(selectedConstructionSegment)">
                  <i class="bi bi-plus"></i> Add Phase
                </button>
              </div>

              <!-- Phases List -->
              <div class="phases-list" *ngIf="selectedConstructionSegment.construction.phases.length > 0">
                <h5>Phases ({{ selectedConstructionSegment.construction.phases.length }})</h5>
                <div class="phase-item" 
                     *ngFor="let phase of selectedConstructionSegment.construction.phases; let i = index"
                     (click)="selectPhase(phase)">
                  <div class="phase-info">
                    <div class="phase-order">{{ phase.order }}</div>
                    <div class="phase-details">
                      <strong>{{ phase.name }}</strong>
                      <div class="phase-description">{{ phase.description }}</div>
                      <div class="phase-properties">
                        <span class="status-badge" 
                              [style.background-color]="getPhaseStatusColor(phase.status)">
                          {{ phase.status | titlecase }}
                        </span>
                        <span class="cost">₹{{ phase.estimatedCost }}</span>
                        <span class="duration">{{ phase.estimatedDuration }} days</span>
                        <span class="progress">{{ phase.progress }}%</span>
                      </div>
                    </div>
                  </div>
                  <div class="phase-actions">
                    <button class="btn-small" 
                            (click)="deletePhase(phase, selectedConstructionSegment); $event.stopPropagation()"
                            title="Delete Phase">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- No phases message -->
              <div class="no-phases" *ngIf="selectedConstructionSegment.construction.phases.length === 0">
                <i class="bi bi-list-ol"></i>
                <p>No phases created yet</p>
                <p>Add phases to organize construction workflow</p>
              </div>
            </div>
          </div>

          <!-- Progress Tab -->
          <div class="tab-content" data-tab="progress">
            <div class="progress-management">
              <h4>Construction Progress</h4>
              
              <!-- Overall Progress -->
              <div class="overall-progress" *ngIf="selectedConstructionSegment.construction">
                <h5>Overall Progress</h5>
                <div class="progress-bar">
                  <div class="progress-fill" 
                       [style.width.%]="calculateConstructionProgress(selectedConstructionSegment)"
                       [style.background-color]="getConstructionStatusColor(selectedConstructionSegment.construction.status)">
                  </div>
                </div>
                <div class="progress-text">
                  {{ calculateConstructionProgress(selectedConstructionSegment) }}% Complete
                </div>
              </div>

              <!-- Construction Details -->
              <div class="construction-details" *ngIf="selectedConstructionSegment.construction">
                <h5>Construction Details</h5>
                <div class="detail-grid">
                  <div class="detail-item">
                    <label>Type:</label>
                    <span>{{ selectedConstructionSegment.construction.type | titlecase }}</span>
                  </div>
                  <div class="detail-item">
                    <label>Status:</label>
                    <span class="status-badge" 
                          [style.background-color]="getConstructionStatusColor(selectedConstructionSegment.construction.status)">
                      {{ selectedConstructionSegment.construction.status | titlecase }}
                    </span>
                  </div>
                  <div class="detail-item">
                    <label>Priority:</label>
                    <span class="priority-badge" 
                          [style.background-color]="getPriorityColor(selectedConstructionSegment.construction.priority)">
                      {{ selectedConstructionSegment.construction.priority | titlecase }}
                    </span>
                  </div>
                  <div class="detail-item">
                    <label>Estimated Cost:</label>
                    <span>₹{{ selectedConstructionSegment.construction.estimatedCost }}</span>
                  </div>
                  <div class="detail-item">
                    <label>Actual Cost:</label>
                    <span>₹{{ selectedConstructionSegment.construction.actualCost }}</span>
                  </div>
                  <div class="detail-item">
                    <label>Estimated Duration:</label>
                    <span>{{ selectedConstructionSegment.construction.estimatedDuration }} days</span>
                  </div>
                  <div class="detail-item">
                    <label>Actual Duration:</label>
                    <span>{{ selectedConstructionSegment.construction.actualDuration }} days</span>
                  </div>
                  <div class="detail-item">
                    <label>Contractor:</label>
                    <span>{{ selectedConstructionSegment.construction.contractor || 'Not assigned' }}</span>
                  </div>
                  <div class="detail-item">
                    <label>Supervisor:</label>
                    <span>{{ selectedConstructionSegment.construction.supervisor || 'Not assigned' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Map Area -->
    <div class="map-area">
      <!-- Toolbar -->
      <div class="map-toolbar">
        <!-- Row 1: Navigation/Selection -->
        <div class="toolbar-row">
          <button class="toolbar-btn" (click)="zoomIn()" title="Zoom In">
            <i class="bi bi-plus"></i>
          </button>
          <button class="toolbar-btn" (click)="zoomOut()" title="Zoom Out">
            <i class="bi bi-dash"></i>
          </button>
          <button class="toolbar-btn" (click)="fitToExtent()" title="Fit to Extent">
            <i class="bi bi-arrows-fullscreen"></i>
          </button>
          <button class="toolbar-btn" (click)="goToExtent()" title="Go to Extent">
            <i class="bi bi-bullseye"></i>
          </button>
          <button class="toolbar-btn" (click)="pan()" title="Pan">
            <i class="bi bi-hand-index"></i>
          </button>
          <button class="toolbar-btn" (click)="select()" title="Select">
            <i class="bi bi-cursor"></i>
          </button>
          <button class="toolbar-btn" (click)="edit()" title="Edit">
            <i class="bi bi-pencil"></i>
          </button>
          <button class="toolbar-btn" (click)="delete()" title="Delete">
            <i class="bi bi-trash"></i>
          </button>
        </div>

        <!-- Row 2: Measurement/History -->
        <div class="toolbar-row">
          <button class="toolbar-btn" (click)="measureDistance()" title="Distance">
            <i class="bi bi-rulers"></i>
          </button>
          <button class="toolbar-btn" (click)="measureArea()" title="Area">
            <i class="bi bi-hexagon"></i>
          </button>
          <button class="toolbar-btn" (click)="measureBearing()" title="Bearing">
            <i class="bi bi-compass"></i>
          </button>
          <button class="toolbar-btn" (click)="undo()" title="Undo">
            <i class="bi bi-arrow-left"></i>
          </button>
          <button class="toolbar-btn" (click)="redo()" title="Redo">
            <i class="bi bi-arrow-right"></i>
          </button>
          <button class="toolbar-btn" (click)="clear()" title="Clear">
            <i class="bi bi-trash"></i>
          </button>
        </div>

        <!-- Row 3: File/View/Help -->
        <div class="toolbar-row">
          <button class="toolbar-btn" (click)="export()" title="Export">
            <i class="bi bi-folder-arrow-up"></i>
          </button>
          <button class="toolbar-btn" (click)="triggerFileInput()" title="Import">
            <i class="bi bi-folder-arrow-down"></i>
          </button>
          <button class="toolbar-btn" (click)="print()" title="Print">
            <i class="bi bi-printer"></i>
          </button>
          <button class="toolbar-btn" (click)="fullscreen()" title="Full Screen">
            <i class="bi bi-fullscreen"></i>
          </button>
          <button class="toolbar-btn" (click)="showMiniMap()" title="Mini Map">
            <i class="bi bi-book"></i>
          </button>
          <button class="toolbar-btn" (click)="showHelp()" title="Help">
            <i class="bi bi-question-circle"></i>
          </button>
        </div>
      </div>

      <!-- Map Container -->
      <div class="map-container">
        <div #mapContainer class="ol-map"></div>
        <div #popup class="ol-popup">
          <a href="#" class="ol-popup-closer"></a>
          <div class="ol-popup-content"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="coordinate-info">
      <span>{{ getCoordinatesString() }}</span>
      <span>|</span>
      <span>{{ getScaleString() }}</span>
      <span>|</span>
      <span>{{ getZoomString() }}</span>
    </div>
  </div>

  <!-- Hidden file input for import -->
  <input type="file" 
         id="fileInput"
         accept=".geojson,.json" 
         (change)="import($event)"
         style="display: none;" 
         #fileInput>

  <!-- Hidden file input for segment import -->
  <input type="file" 
         id="segmentFileInput"
         accept=".json" 
         (change)="importSegments($event)"
         style="display: none;" 
         #segmentFileInput>
</div>